// extracted by mini-css-extract-plugin
export var legendIndicator = "_c7-1";
export var legendRight = "_c7-0";